import React from "react";
import { connect } from "react-redux";
import Paso from "./paso.cmpt";
import Poliza from "./poliza.cmpt";
import Datos from "./datos.cmpt";
import Correo from "./correo.cmpt";
import { callService } from "../tools";
import firebase from 'firebase';
import { servicios } from "../properties";

const mapState = (state) => {
	return {
		loading: state.global.loading,
		completo: state.registro.completo,
		paso: state.registro.paso,
	};
};

const mapDispatch = (dispatch) => {
	return {
		limpiarRegistro: () => {
			dispatch({ "type": "LIMPIAR_REGISTRO" });
		},
		setPaso: (paso) => {
			dispatch({ "type": "REGISTRO_PASO", "paso": paso });
		},
		loaderHide: () => {
			dispatch({ "type": "LOADER_HIDE" });
		}
	};
};

const obtenerHash = "registro.obtenerurlregistro";

class RegistroForm extends React.Component {

	componentWillMount = () => {
		if (this.props.completo) {
			this.props.limpiarRegistro();
		}
	}

	componentDidMount = () => {
		this.guardarDatosFirebase();
		this.mostrarModalNativo();
		
		const url = window.location.hash;
		var main = document.getElementsByClassName("main")[0];

		if (url.includes("#!/gnp/registro") || url.includes("#!/gnp/registro-familiar")) {
			main.style.width = "1250px";
		}

		if (this.props.hashOne && this.props.hashTwo && this.props.hashOne !== undefined && this.props.hashTwo !== undefined) {
			new callService({
				service: obtenerHash,
				secure: false,
				data: { valor: this.props.hashOne, encripta: true }
			}).execute().then(email => {
				console.log("email", email);
				new callService({
					service: obtenerHash,
					secure: false,
					data: { valor: this.props.hashTwo, encripta: true }
				}).execute().then(bandera => {
					console.log("bandera", bandera);
					localStorage.setItem("banConcluirReg", bandera.hash);
					localStorage.setItem("correoInconcluso", email.hash);
					localStorage.setItem("correoModal", email.hash);
					const banConcluirReg = localStorage.getItem("banConcluirReg");
					if (banConcluirReg === "false" || localStorage.getItem("registroAsistido") === "true") {
						this.props.setPaso(1);
						this.props.loaderHide();
					} else {
						localStorage.removeItem("banConcluirReg");
					}
				}).catch(error => {
					console.log("error hash Pass submit", error);
				});

			}).catch(error => {
				console.log("error hash Pass submit", error);
			});
		} else {
			const banConcluirReg = localStorage.getItem("banConcluirReg");
			console.log("ELSE");
			if (banConcluirReg === "false" || localStorage.getItem("registroAsistido") === "true") {
				this.props.setPaso(1);
				this.props.loaderHide();
			} else {
				localStorage.removeItem("banConcluirReg");
				localStorage.removeItem("correoInconcluso");
				localStorage.removeItem("correoModal");
			}
		}
	}

	guardarDatosFirebase = () => {
		const url = new URL(`${servicios.hostBackend}/horario/whats-config/modalRegistro`);
        const requestOptions = {
			method: 'GET',
			headers: { 
			'Content-Type': 'application/json'
			},
		};
        fetch(url, requestOptions)
        .then(response => response.json())
        .then(config => {

            if (config.error) {
                console.log("error", config.errorMessage);
            } else {
				localStorage.setItem("btnAyuda", config.show);
				localStorage.setItem('dataFirebase2', JSON.stringify(config));                       
            }

			firebase.database().ref("/config/whatsapp/modalRegistroInfo").once("value").then(oValue => {
				const data = oValue.val();
	
				if(data) {
					localStorage.setItem('dataFirebase', JSON.stringify(data));
				}
			});

        }).catch(error => {
            console.error("Error en la configuracion de whats.", error);
        }); 
	}

	mostrarModalNativo = () => {
		firebase.database().ref("/config/whatsapp/modalRegistroInfo/showModalNativo").once("value").then(oValue => {
			const data = oValue.val();

			if(data) {
				localStorage.setItem("verModalNativo", data);                       
			}
		});
	}

	render() {
		return (
			<div>
				<div className="gnpRegistro">
					<Paso />
					{this.props.paso == 0 &&
						<Poliza />
					}
					{this.props.paso == 1 &&
						<Datos />
					}
					{this.props.paso == 3 &&
						<Correo />
					}
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(RegistroForm);



// WEBPACK FOOTER //
// ./src/gnp-registro/flujo.cmpt.js